import { render, staticRenderFns } from "./EmpleadoBaja.vue?vue&type=template&id=79b88e84&"
import script from "./EmpleadoBaja.vue?vue&type=script&lang=js&"
export * from "./EmpleadoBaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports